$(document).ready(function () {
    "use strict";

    $(document).on('click', '.js_financeProduct', function(e) {
        e.preventDefault();

        $('.financeContentMobileTab').removeClass('active');
        $(this).parent().addClass('active');

        $('.financeExampleNewWrap .financeWhyChoose').removeClass('active');
        $('.financeExampleNewWrap .financeExampleBlock ul').removeClass('active');

        $('.financeExampleNewWrap .financeWhyChoose').eq($(this).closest('.financeContentMobileTab').index()).addClass('active');
        $('.financeExampleNewWrap .financeExampleBlock ul').eq($(this).closest('.financeContentMobileTab').index()).addClass('active');


        $('.financeContentMobile .financeWhyChoose').removeClass('active');
        $('.financeContentMobile .mobileColumn').removeClass('active');

        $('.financeContentMobile .financeWhyChoose').eq($(this).closest('.financeContentMobileTab').index()).addClass('active');
        $('.financeContentMobile .mobileColumn').eq($(this).closest('.financeContentMobileTab').index()).addClass('active');
    });
});